import { useLocation } from 'react-router';
import { getUrlParams } from 'utils/urlParams';

export const useListId = () => {
  const { search } = useLocation();
  const { emailListId } = getUrlParams(search);

  return emailListId ? parseInt(emailListId, 10) : undefined;
};
